<template>
  <div class="index-page">
    <div class="app-area" v-loading="isLoading">
      <div class="apps-toolbar">
        <el-select
          v-model="currentSelect"
          placeholder="选择分类方式"
          size="mini"
        >
          <el-option
            v-for="item in selectOption"
            :key="item.value"
            :label="item.label"
            :value="item.value"
            :disabled="item.disabled"
          >
          </el-option>
        </el-select>
      </div>
      <div v-if="false"></div>
      <div v-if="isError">
        <el-alert
          title="出错了"
          :description="errorMessage"
          type="error"
          close-text="重试"
          @close="requestData"
        >
        </el-alert>
      </div>
      <div
        v-for="(item0, index0) in combine(appGroup, currentSelect, apps)"
        :key="index0"
      >
        <div
          class="app-group"
          v-show="
            apps.filter((item) => item[currentSelect] === item0).length > 0
          "
        >
          <div class="app-group-title-area">
            <h3>{{ item0 }}</h3>
            <div class="underline-area"></div>
          </div>
          <div class="app-show-list">
            <div
              class="app-show-item"
              v-for="(item, index) in apps.filter(
                (item) => item[currentSelect] === item0
              )"
              :key="item.id"
            >
              <div class="app-show-item-pkg">
                <a
                  :href="item.url"
                  :title="item.title"
                  @click="itemClick(item, $event)"
                  @contextmenu="itemClick(item, $event, true)"
                  target="_blank"
                  class="app-show-item-icon-area"
                  :style="{ background: item.background_color }"
                  rel="noopener noreferrer"
                >
                  <img
                    :src="item.icon_image"
                    onerror="this.src = '/static/licp/images/app-icons/app.svg'"
                    class="app-show-item-icon"
                  />
                </a>
                <div class="app-show-item-title-area">
                  <a
                    :href="item.url || 'javascript:void(0);'"
                    :title="item.title"
                    @click="itemClick(item, $event)"
                    target="_blank"
                    class="app-show-item-title-link"
                    rel="noopener noreferrer"
                    >{{
                      ("" + item.title).substring(0, 4) === "汇泽医养"
                        ? ("" + item.title).substring(4)
                        : item.title
                    }}</a
                  >
                </div>
              </div>
            </div>
            <div
              class="app-show-item item-ske"
              v-for="(item, index) in [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]"
            ></div>
          </div>
        </div>
      </div>
    </div>
    <!--对话框部分-->
    <el-dialog
      :title="currentItem.title || '提示'"
      :visible.sync="dialogVisible"
      width="600px"
      :append-to-body="true"
    >
      <div slot="title" class="dialog-title">
        <img class="dialog-title-image" :src="currentItem.icon_image" />
        <span class="dialog-title-text">{{ currentItem.title || "提示" }}</span>
      </div>
      <div>
        <!-- v-if="currentItem.prevent_text"-->
        <el-alert
          v-if="currentItem.source_type !== 'url'"
          type="warning"
          :description="
            currentItem.prevent_text
              ? '' + currentItem.prevent_text
              : '您访问的是非URL链接或非B/S架构的应用'
          "
          show-icon
          :closable="false"
          effect="light"
        >
        </el-alert>
        <div class="dialog-link" v-if="currentItem.url">
          <el-link
            type="primary"
            :href="currentItem.url"
            target="_blank"
            rel="noopener noreferrer"
            >{{
              `${
                currentItem.arch !== "B/S架构" ||
                currentItem.prevent_text ||
                currentItem.source_type !== "url"
                  ? `忽略提示，继续`
                  : ""
              }访问“${currentItem.title}”>>`
            }}</el-link
          >
        </div>
      </div>
      <div>
        <el-descriptions title="" border size="small">
          <el-descriptions-item label="适用范围">{{
            currentItem.purpose
          }}</el-descriptions-item>
          <el-descriptions-item label="采购方">{{
            currentItem.investor
          }}</el-descriptions-item>
          <el-descriptions-item label="作者"
            >{{ currentItem.author }}
            <a
              href="javascript:;"
              class="more"
              v-if="
                typeof currentItem.author_infomation === 'object' &&
                currentItem.author_infomation &&
                Object.keys(currentItem.author_infomation).length > 0 &&
                !isAuthorOpen
              "
              @click.prevent="isAuthorOpen = !isAuthorOpen"
            >
              {{ `更多>>` }}
            </a>
          </el-descriptions-item>
          <el-descriptions-item
            v-for="(item0, index0) in generateAuthorInfo(
              currentItem.author_infomation
            )"
            :key="index0"
            :label="item0.key"
            >{{ item0.value }}</el-descriptions-item
          >
        </el-descriptions>
      </div>
      <div v-if="currentItem.description" class="dialog-description-area">
        <p>{{ currentItem.description }}</p>
      </div>
      <div
        v-show="false"
        v-for="(item0, index0) in generateAuthorInfo(
          currentItem.author_infomation
        )"
        :key="index0"
      >
        {{ item0.value }}
      </div>
      <div
        class="dialog-relevancy"
        v-if="
          typeof currentItem.sources_link === 'object' &&
          currentItem.sources_link
        "
      >
        <el-card class="dialog-box-card">
          <div slot="header" class="dialog-card-header">
            <h5>相关资源</h5>
          </div>
          <div
            class="dialog-card-list-item"
            v-for="(item0, index0) in currentItem.sources_link"
            :key="index0"
          >
            <span>{{ `${index0}:` }}</span>
            <el-link :href="item0" target="_blank" rel="noopener noreferrer">{{
              item0
            }}</el-link>
          </div>
        </el-card>
      </div>
      <span> </span>
      <!--
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
            </span>
            -->
    </el-dialog>
  </div>
</template>

<script>
/**
        // interface DataType {
        //     id:number|string;
        //     title:string;
        //     description:string;
        //     icon_image:string;
        //     background_color:string;
        //     purpose:string|'养老区'|'医疗区'|'集团公司'|'行政'|'后勤'|'智慧民政'|'其他';//用途
        //     investor:string|'公司内部'|'民政'|'自研开发';//采购方
        //     author:string;
        //     author_infomation:string;
        //     network_range:string|'医疗内网'|'养老内网'|'临时内网'|'互联网'|'无网应用';//网络环境
        //     arch:string|'B/S架构'|'C/S架构'|'APP'|'小程序';//应用体现形式
        //     source_type:string|'url'|'桌面应用';//应用类别
        //     url:string;
        // }

    */
export default {
  data() {
    return {
      apps: [],
      appGroup: {
        purpose: [
          "集团公司",
          "智慧民政",
          "养老区",
          "医疗区",
          "行政",
          "人事",
          "后勤",
          "其他",
        ],
        investor: ["民政", "公司内部", "自研开发"],
        network_range: [
          "互联网",
          "医疗内网",
          "养老内网",
          "临时内网",
          "混联网络",
          "单机",
        ],
        arch: ["B/S架构", "C/S架构", "APP", "小程序"],
      },
      currentSelect: "purpose",
      selectOption: [
        { value: "purpose", label: "按适用范围分类", disabled: false },
        { value: "investor", label: "按系统采购方分类", disabled: false },
        { value: "network_range", label: "按网络类型分类", disabled: false },
        { value: "arch", label: "按系统架构分类", disabled: false },
      ],
      currentItem: {},
      dialogVisible: false,
      isLoading: true,
      isError: false,
      errorMessage: "",
      isAuthorOpen: false,
    };
  },
  methods: {
    combine(appGroup, currentSelect, apps) {
      if (typeof appGroup !== "object" || !appGroup) {
        return [];
      }
      if (typeof currentSelect !== "string" || !appGroup[currentSelect]) {
        currentSelect = "purpose";
      }
      if (typeof apps !== "object" || !Array.isArray(apps)) {
        return [];
      }
      const otherItems = apps.map((item) => item[currentSelect]);
      return [...new Set([...appGroup[currentSelect], ...otherItems])];
    },
    itemClick(item, event, forceOpen) {
      if (item.source_type !== "url" || forceOpen) {
        event.preventDefault();
        this.currentItem = item;
        this.dialogVisible = true;
        this.isAuthorOpen = false;
      }
    },
    requestData() {
      this.isError = false;
      this.isLoading = true;
      this.$http
        .get("/api/licp/apps_all.json", {})
        .then((response) => {
          return response.data;
        })
        .then((data) => {
          this.apps = data.data;
          this.isLoading = false;
        })
        .catch((response) => {
          //console.log('错误',error);
          this.$message.error(`[${response.status}]${response.statusText}`);
          this.isLoading = false;
          this.isError = true;
          this.errorMessage = `[${response.status}]${response.statusText}`;
        });
    },
    generateAuthorInfo(infos) {
      var res = [];
      if (!this.isAuthorOpen) {
        return res;
      }
      if (Array.isArray(infos)) {
        res = [...infos];
      } else {
        if (typeof infos === "object" && infos) {
          res = Object.entries(infos).map(([key, value]) => ({ key, value }));
        } else {
          res = [];
        }
      }
      // console.log(res);
      return res;
    },
  },
  created() {
    //console.log('created',this.apps);
    this.requestData();
  },
};
</script>

<style scoped>
.index-page {
  background-color: transparent;
}
.app-show-list {
  display: flex;
  flex-shrink: 0;
  flex-direction: row;
  justify-content: space-around;
  padding: 0;
  flex-wrap: wrap;
  margin-bottom: 15px;
}
.app-show-item {
  display: flex;
  width: 145px;
  height: 115px;
}
.app-show-item-pkg {
  margin: 10px 25px;
  display: block;
  width: 95px;
  height: 95px;
}
.app-show-item-icon-area {
  margin: 0 auto;
  width: 65px;
  height: 65px;
  overflow: hidden;
  border-radius: 7px;
  background-color: transparent;
  user-select: none;
  -webkit-user-drag: none;
  cursor: pointer;
  box-shadow: 0 0 3px lightgray;
  display: flex;
  justify-content: center;
  align-items: center;
}
.app-show-item-icon {
  width: 90%;
  height: 90%;
}
.app-show-item-title-area {
  margin: 0 auto;
  text-align: center;
  line-height: 30px;
  width: 95px;
  font-size: 12px;
  cursor: pointer;
  user-select: none;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.app-show-item-title-link {
  color: #303133;
  text-decoration: none;
}
.item-ske {
  height: 0;
  padding: 0;
  margin: 0;
}
.app-group-title-area {
  height: 35px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  /*
        background-image:linear-gradient(to right,lightblue,transparent);
        */
  padding: 0 2em;
  font-family: "黑体";
  font-weight: bold;
  font-size: 16px;
}
.app-group-title-area .underline-area {
  margin-top: 4px;
  width: 120px;
  height: 5px;
  background-image: linear-gradient(to right, #e0e9fb, transparent);
}
.apps-toolbar {
  display: flex;
  justify-content: flex-end;
  padding: 10px;
}
.dialog-link {
  padding: 1em 0;
  text-align: right;
}
/* .dialog-link a{
    } */
.dialog-card-list-item {
  margin-bottom: 9px;
}
.dialog-card-header h5 {
  font-weight: bold;
}
.dialog-relevancy {
  margin-top: 9px;
}
.dialog-title {
  display: flex;
  align-items: center;
}
.dialog-title-image {
  width: 18px;
  height: 18px;
  object-fit: cover;
}
.dialog-title-text {
  font-weight: bold;
  font-size: 15px;
}
.dialog-description-area {
  margin-top: 15px;
  margin-bottom: 15px;
  text-indent: 2em;
}
.more {
  color: rgb(96, 98, 102);
}
</style>



// WEBPACK FOOTER //
// src/pages/App.vue